module.exports = __webpack_public_path__ + "img/mobile.232a5b53.svg";